import React from 'react';
import { Dumbbell } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2D3748] text-white py-12 border-t border-gray-800" data-id="element-11">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-12">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-13">
          <div className="flex items-center gap-2" data-id="element-14">
            <div className="bg-[#FF6B35] p-2 rounded-lg" data-id="element-15">
              <Dumbbell className="h-6 w-6 text-white" data-id="element-16" />
            </div>
            <span className="text-xl font-bold tracking-tight" data-id="element-17">Iron Gym</span>
          </div>

          <p className="text-gray-400 text-sm" data-id="element-18">
            Plataforma de retenção inteligente para academias.
          </p>

          <div className="text-sm text-gray-500" data-id="element-19">
            &copy; {new Date().getFullYear()} Iron Gym. Todos os direitos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
}